import React from 'react';
import { Info } from 'lucide-react';
import { toast } from 'sonner';
import AppModal from '../../../common/AppModal';
import { REQUEST_HOA_DISPLAY_FIELDS } from '../../../hoaForm/hoaFormData';
import { copyToClipboard } from '../../../../helpers/global';

const RequestHoaInfoModal = ({ show, onHide, requestHoaInfo = [] }) => {
  const entries = (Array.isArray(requestHoaInfo) ? requestHoaInfo : []).filter(h => h?.name);

  return (
    <AppModal
      show={show}
      onHide={onHide}
      onSubmit={onHide}
      heading={
        <span className="d-flex align-items-center">
          <Info size={16} className="mr-2 text-info" />
          Client-requested HOA information
        </span>
      }
      submitLabel="Close"
      showCancelButton={false}
      submitButtonVariant="secondary"
      size="md"
    >
      <p className="text-muted midFont mb-3">
        HOA details entered by the client at order placement.
      </p>
      {entries.map((hoa, index) => (
        <div
          key={index}
          className={`p-3 border rounded bg-light${index > 0 ? ' mt-3' : ''}`}
          style={{ borderColor: '#dee2e6' }}
        >
          {entries.length > 1 && (
            <p className="font-weight-semibold midFont mb-2">HOA {index + 1}</p>
          )}
          {REQUEST_HOA_DISPLAY_FIELDS.map(({ key, label }) => {
            const value = hoa[key];
            if (!value) return null;
            return (
              <div key={key} className="d-flex justify-content-between py-1 midFont">
                <span className="text-muted flex-shrink-0 mr-3">{label}</span>
                <span
                  className="font-weight-semibold text-right"
                  style={{ wordBreak: 'break-word', cursor: 'pointer' }}
                  onMouseEnter={e => {
                    e.currentTarget.style.opacity = '0.7';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.opacity = '1';
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    copyToClipboard(value);
                    toast.success('Copied to clipboard!');
                  }}
                >
                  {value}
                </span>
              </div>
            );
          })}
        </div>
      ))}
    </AppModal>
  );
};

export default RequestHoaInfoModal;
